import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { FaAngleLeft, FaAngleRight, FaFileUpload } from "react-icons/fa";
const BankInfomatiom = ({
  register,
  handleSubmit,
  errors,
  onSubmit,
  watch,
  setTabs,
}) => {
  const [licenseFile, setLicenseFile] = useState(null);

  return (
    <div>
      {" "}
      <form className="space-y-5 px-1 py-10 " onSubmit={handleSubmit(onSubmit)}>
        <div>
          <label className="block font-medium mb-1">Default Currency</label>
          <select
            {...register("default", { required: true })}
            className="w-full border rounded-md p-3 outline-none focus:ring-2 focus:ring-green-700"
          >
            <option value="">Select Type</option>
            <option value="ngo">Select1</option>
            <option value="ngo">Select2</option>
          </select>
          {errors.default && (
            <p className="text-sm text-red-500">default type is required</p>
          )}
        </div>

        <div>
          <label className="block font-medium mb-1">Bank Name</label>
          <input
            type="text"
            {...register("bank")}
            placeholder="Enter bank"
            className="w-full border rounded-md p-3 outline-none focus:ring-2 focus:ring-green-700"
          />
        </div>

        <div>
          <label className="block font-medium mb-1">Account Number </label>
          <input
            type="url"
            {...register("banknumber")}
            placeholder="Enter Account Number"
            className="w-full border rounded-md p-3 outline-none focus:ring-2 focus:ring-green-700"
          />
        </div>

        <div>
          <label className="block font-medium mb-1">IFSC or SWIFT Code </label>
          <input
            type="url"
            {...register("ifsc")}
            placeholder="Enter Account Number"
            className="w-full border rounded-md p-3 outline-none focus:ring-2 focus:ring-green-700"
          />
        </div>

        <div>
          <label className="block font-medium mb-1">
            Passbook / Cancelled Cheque
          </label>
          <div className="flex items-center w-full border rounded-lg px-3 py-2 focus-within:ring-2 focus-within:ring-green-600">
            <input
              type="file"
              accept="application/pdf,image/*"
              id="license-upload"
              className="hidden"
              {...register("passbook", {
                required: true,
                onChange: (e) => {
                  const fileSelected = e.target.files[0];
                  setLicenseFile(fileSelected); // update local state for preview
                },
              })}
            />
            <label
              htmlFor="license-upload"
              className="flex-grow cursor-pointer text-sm text-gray-500 truncate"
            >
              {licenseFile ? licenseFile.name : "Upload Passbook"}
            </label>
            <label htmlFor="license-upload" className="cursor-pointer">
              <FaFileUpload className="text-[25px]" />
            </label>
          </div>

          {/* Error message */}
          {errors.passbook && (
            <p className="text-sm text-red-500">
              Passbook / Cancelled Cheque is required
            </p>
          )}
        </div>

        {/* Buttons */}
        <div className="flex justify-between mt-6">
          <button
            onClick={() => setTabs(2)}
            type="button"
            className="px-3 flex items-center gap-10 py-2 rounded-full bg-green-800 text-white hover:bg-green-900"
          >
            <FaAngleLeft /> Back
          </button>

          {/* ✅ Next should SUBMIT instead of just switching tab */}
          <button
            onClick={handleSubmit(() => setTabs(4))}
            type="submit"
            className="px-3 flex items-center gap-10 py-2 rounded-full bg-green-800 text-white hover:bg-green-900"
          >
            Next <FaAngleRight />
          </button>
        </div>
      </form>
    </div>
  );
};

export default BankInfomatiom;
